import { render, staticRenderFns } from "./product_type_list.vue?vue&type=template&id=06c83bce"
import script from "./product_type_list.vue?vue&type=script&lang=js"
export * from "./product_type_list.vue?vue&type=script&lang=js"
import style0 from "./product_type_list.vue?vue&type=style&index=0&id=06c83bce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports